export function cleanPhoneNumber(phoneNumber?: string): string | undefined {
  if (!phoneNumber) return phoneNumber;
  phoneNumber = phoneNumber.trim();
  phoneNumber = phoneNumber.replace(/\s+/g, ""); // Remove all whitespace
  phoneNumber = phoneNumber.replace("+", ""); // Remove "+" from international prefix
  return phoneNumber;
}
